import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrDZ: CultureInfo = {
  name: 'fr-DZ',
  displayName: 'français (Algérie)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-DZ',
  parent: CultureInfoFr
};
